import React from 'react';
import { Provider } from 'react-redux';
import Loadable from 'react-loadable';

import createStore from '../redux/store';
import Loading from 'lib/components/Loading'; // eslint-disable-line

const UpdateStripeInfoContainer = Loadable({
  loader: () => import('../containers/UpdateStripeInfoContainer'),
  loading: Loading,
});

export default props => {
  const store = createStore(props);
  const reactComponent = (
    <Provider store={store}>
      <UpdateStripeInfoContainer />
    </Provider>
  );
  return reactComponent;
};
